module.exports = __webpack_public_path__ + "@/assets/img/good_logo_white.5caacf95.svg";